import Vue from 'vue'
import Router from 'vue-router'
import newCustomer from '@/components/Customer/newCustomer.vue'
import newProduct from '@/components/Product/newProduct.vue'
import Mobility from '@/components/Mobility/Mobility.vue'
import Login from '@/views/Login.vue'
import Roles from '@/views/Roles.vue'
import Supplies from '@/views/Supplies.vue'
import Assets from '@/views/Assets.vue'
import Sales from '@/views/sales/Sales.vue'
import Orders from '@/views/orders/Orders.vue'
import Production from '@/views/production/Production.vue'
import Purchases from '@/views/production/Purchases.vue'
import Providers from '@/views/production/Providers.vue'
import Inventory from '@/views/production/Inventory.vue'
import Debts from '@/views/debts/Debts.vue'
import ProviderAccount from '@/views/providers/ProviderAccount.vue'
import Storehouse from '@/views/storehouses/Storehouse.vue'
import Cashflow from '@/views/cashflow/Cashflow.vue'
import ReportPurchases from '@/views/reports/Purchases.vue'
import ReportDebts from '@/views/reports/Debts.vue'
import ReportSales from '@/views/reports/Sales.vue'
import ReportOrders from '@/views/reports/Orders.vue'
import HistoryCash from '@/views/cashflow/HistoryCash.vue'
import Dashboard from '@/views/dashboard/Dashboard.vue'
import Users from '@/views/users/User.vue'
import RecipesList from '@/views/recipes/RecipesList.vue';
import CreateRecipe from '@/views/recipes/CreateRecipe.vue';
import InventoriesProducts from '@/views/inventories/InventoriesProducts.vue';
import KardexProducts from '@/views/inventories/KardexProducts.vue';
import KardexSupply from '@/views/production/KardexSupply.vue';
import Printers from '@/views/printers/Printers.vue';
import CreateProduct from '@/views/products/CreateProduct.vue';
import UpdateProduct from '@/views/products/UpdateProduct.vue';
import Brands from '@/views/brands/Brands.vue';
import Variants from '@/views/variants/Variants.vue';
import Patterns from '@/views/patterns/Patterns.vue';
import Colors from '@/views/colors/Colors.vue';
import ReportCreditNotes from '@/views/reports/CreditNotes.vue';
import Importations from '@/views/importations/Importations';
import ReportImportations from '@/views/reports/Importations';

Vue.use(Router)

export default new Router({
    routes: [
        {
          path: '/',
          name: 'login',
          component: Login
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
          path: '/customers',
          name: 'customers',
          component: newCustomer
        },
        {
          path: '/products',
          name: 'products',
          component: newProduct
        },
        {
          path: '/mobilities',
          name: 'mobilities',
          component: Mobility
        },
        {
          path: '/recipes',
          name: 'recipes',
          component: RecipesList
        },
        {
          path: '/create-recipes',
          name: 'create-recipes',
          component: CreateRecipe
        },
        {
          path: '/roles',
          name: 'roles',
          component: Roles
        },
        {
          path: '/supplies',
          name: 'supplies',
          component: Supplies
        },
        {
          path: '/assets',
          name: 'assets',
          component: Assets
        },
        {
          path: '/sales',
          name: 'sales',
          component: Sales
        },
        {
          path: '/orders',
          name: 'orders',
          component: Orders
        },
        {
          path: '/production',
          name: 'production',
          component: Production
        },
        {
          path: '/debts',
          name: 'debts',
          component: Debts
        },
        {
          path: '/purchases',
          name: 'purchases',
          component: Purchases
        },
        {
          path: '/providers',
          name: 'providers',
          component: Providers
        },
        {
          path: '/inventory',
          name: 'inventory',
          component: Inventory
        },
        {
          path: '/products-inventory',
          name: 'products-inventory',
          component: InventoriesProducts
        },
        {
          path: '/products-kardex',
          name: 'products-kardex',
          component: KardexProducts
        },
        {
          path: '/supply-kardex',
          name: 'supply-kardex',
          component: KardexSupply
        },
        {
          path: '/provider-account',
          name: 'provider-account',
          component: ProviderAccount
        },
        {
          path: '/storehouses',
          name: 'storehouses',
          component: Storehouse
        },
        {
          path: '/cashflow',
          name: 'cashflow',
          component: Cashflow
        },
        {
          path: '/report-purchases',
          name: 'report-purchases',
          component: ReportPurchases
        },
        {
          path: '/report-debts',
          name: 'report-debts',
          component: ReportDebts
        },
        {
          path: '/report-sales',
          name: 'report-sales',
          component: ReportSales
        },
        {
          path: '/report-orders',
          name: 'report-orders',
          component: ReportOrders
        },
        {
          path: '/history-cash',
          name: 'history-cash',
          component: HistoryCash
        },
        {
          path: '/report-credit-notes',
          name: 'report-credit-notes',
          component: ReportCreditNotes
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: '/users',
          name: 'users',
          component: Users
        },
        {
          path: '/printers',
          name: 'printers',
          component: Printers
        },
        {
          path: '/create-product',
          name: 'create-product',
          component: CreateProduct
        },
        {
          path: '/update-product',
          name: 'update-product',
          component: UpdateProduct
        },
        {
          path: '/brands',
          name: 'brands',
          component: Brands
        },
        {
          path: '/variants',
          name: 'variants',
          component: Variants
        },
        {
          path: '/models',
          name: 'models',
          component: Patterns
        },
        {
          path: '/colors',
          name: 'colors',
          component: Colors
        },
        {
          path: '/importations',
          name: 'importations',
          component: Importations
        },
        {
          path: '/report-importations',
          name: 'report-importations',
          component: ReportImportations
        }
      ]
})